module.exports = __webpack_public_path__ + "static/media/builtinv2-vikluchateli (1).4f3e0eb9.png";